export default {
  titles: {
    pickup: 'Pickup',
    delivery: 'Delivery',
  },
  buttons: {
    confirm: 'Confirm',
  },
};
